/* eslint-disable @nx/enforce-module-boundaries */
import React from 'react';
import { Box } from '@mybridge/ui/layout';
import { Tooltip } from '@mybridge/ui/tooltip';
import { Button } from '@mybridge/ui/button';
import { MyBMeetingIcon } from './meetingIcons';
import styles from './meeting.module.scss';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useRouter } from 'next/router';
import { isMobile } from 'react-device-detect';

export const MeetingFloatingButton = ({ onClick, isLoading, ...props }) => {
  const { t } = useTranslator();
  const router = useRouter();

  if (isMobile && router?.pathname === "/profile/message") {
    return null;
  }

  return (
    <Tooltip hasArrow placement="auto" variant="round" label={t('common.meetingRoom') || "Meeting Room"}>
      <Box className={styles.startMeetingButtonContainer} {...props}>
        <Button
          className={styles.meetingStartButton}
          onClick={onClick}
          isLoading={isLoading}
          id="meeting-floating-button"
        >
          <MyBMeetingIcon width={20} height={20} />
        </Button>
      </Box>
    </Tooltip>
  );
};

export default MeetingFloatingButton;
